import React, { useState } from "react";
import moment from "moment";
import "moment-timezone";
import Countdown from "react-countdown";
import CountdownRenderer from "../views/components/Auction/AuctionDetail/CountdownRenderer";
import { DATE_TIME_DISPLAY, now as serverNow, nowMs } from "../common/dateTime";

// Prebid runs from the event publish time until bidding starts.
// While it is open, show the time left and when it ends; hide it afterwards.
const PrebidCountdown = ({ eventDetails, timeZone, className, onEnd }) => {
  const [ended, setEnded] = useState(false);
  const { previewPeriod, publishDateTime, bidStartDateTime } = eventDetails;

  const now = serverNow();
  const isOpen =
    previewPeriod !== "NO" &&
    moment(bidStartDateTime).isValid() &&
    now.isSameOrAfter(moment(publishDateTime)) &&
    now.isBefore(moment(bidStartDateTime));

  if (ended || !isOpen) return null;

  return (
    <span className={className}>
      Prebid ends in{" "}
      <Countdown
        now={nowMs}
        key={bidStartDateTime}
        date={moment(bidStartDateTime).toDate()}
        renderer={(args) => CountdownRenderer(false, args, false)}
        onComplete={() => {
          setEnded(true);
          if (onEnd) onEnd();
        }}
      />{" "}
      ·{" "}
      {moment(bidStartDateTime).tz(timeZone).format(DATE_TIME_DISPLAY)}
    </span>
  );
};

export default PrebidCountdown;
